<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M13 6.66683H1M9.66667 1.3335V4.00016M4.33333 1.3335V4.00016M4.2 14.6668H9.8C10.9201 14.6668 11.4802 14.6668 11.908 14.4488C12.2843 14.2571 12.5903 13.9511 12.782 13.5748C13 13.147 13 12.5869 13 11.4668V5.86683C13 4.74672 13 4.18667 12.782 3.75885C12.5903 3.38252 12.2843 3.07656 11.908 2.88482C11.4802 2.66683 10.9201 2.66683 9.8 2.66683H4.2C3.0799 2.66683 2.51984 2.66683 2.09202 2.88482C1.71569 3.07656 1.40973 3.38252 1.21799 3.75885C1 4.18667 1 4.74672 1 5.86683V11.4668C1 12.5869 1 13.147 1.21799 13.5748C1.40973 13.9511 1.71569 14.2571 2.09202 14.4488C2.51984 14.6668 3.0799 14.6668 4.2 14.6668Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
